import React from "react";
import i18next from "../localization/i18n";
import CallIcon from "@mui/icons-material/Call";
import SaitRowAction from "./SaitRowAction";
import { saitfecoreNs } from "../utils/Constants";

/*
	Obbligatori:
		id
		onClick
	Facoltativi:
*/

export default function SaitRowActionCall(props) {
	return SaitRowAction({
		id: props.id,
		icon: <CallIcon color="primary" />,
		tooltip: i18next.t("call_client", { ns: saitfecoreNs }),
		objmod: props.objmod,
		onClick: (params) => {
			window.open("tel:" + props.phoneNumber(params));
		},
		conditionalRendering: (params) => {
			return props.phoneNumber(params);
		},
		roleSecurity: props.roleSecurity,
		hidden: props.hidden,
	});
}
